<template>
  <!-- <VDialog
    :value="open"
    max-width="500px"
    content-class="ns-dropdown-modal"
    @input="handleDialogInput"
  > -->
  <div v-show="open" class="ns-dropdown-modal__temp-container" @click.stop>
    <div class="ns-dropdown-modal__temp-inner">
      <div class="modal-content">
        <div v-show="showCustomInput" class="back-button" @click="handleBack">
          <NsIcon class="back-button-icon" icon-name="icon-chevron-left" />
        </div>
        <div class="close-button" @click="$emit('close')">
          <NsIcon icon-name="icon-close" />
        </div>
        <h3 class="modal-title">
          {{ title }}
        </h3>
        <div v-show="showCustomInput" class="ns-dropdown-modal__custom-input">
          <!-- @slot Slot for custom selected-item area -->
          <div
            class="ns-dropdown-modal__custom-input--border"
            :class="{ 'ns-dropdown-modal__custom-input-error': errorMessage }"
          >
            <slot name="custom" />
            <p v-show="errorMessage" class="ns-dropdown-modal__error-tag">
              {{ errorMessage }}
            </p>
          </div>
          <button
            class="fluid primary-solid"
            :disabled="!!errorMessage"
            @click="$emit('close')"
          >
            {{ translations.done }}
          </button>
        </div>

        <NsSlottedDropdownItems
          v-show="!showCustomInput"
          :selected="selected"
          :using-custom="usingCustom"
          modal
          @select="handleSelect"
        >
          <!-- @slot The list of elements to appear in the dropdown. -->
          <slot />
        </NsSlottedDropdownItems>
      </div>
    </div>
  </div>
  <!-- </VDialog> -->
</template>

<script>
import { NsIcon } from '@nuskin/ns-icon';
import NsSlottedDropdownItems from './NsSlottedDropdownItems.vue';

export default {
  name: 'NsSlottedDropdownModal',
  components: { NsIcon, NsSlottedDropdownItems },
  props: {
    /**
     * Error message. Will show if truthy.
     */
    errorMessage: {
      type: String,
      default: '',
    },
    /**
     * If true, the Modal is open.
     */
    open: Boolean,
    /**
     * Either the index or the value of the item that should be in selected state
     */
    selected: {
      type: [String, Number],
      default: '',
    },
    /**
     * The title displayed at the top of the modal
     */
    title: {
      type: String,
      default: '',
    },
    /**
     * Translations
     */
    translations: {
      type: Object,
      default() {
        return {};
      },
    },
    /**
     * If custom is being used
     */
    usingCustom: Boolean,
  },
  data() {
    return {
      showCustomInput: false,
    };
  },
  watch: {
    open(value) {
      if (value && this.usingCustom) {
        this.showCustomInput = true;
      }

      if (!value) {
        this.showCustomInput = false;
      }
    },
  },
  methods: {
    /**
     * Emits an event whenever an item is selected
     */
    emitSelect(value, index) {
      /**
       * Fired when a menu item is selected: function(value: string|number, index: number) => void
       *
       * @type {select}
       * @property {(string|number)} value data-value attribute of the selected item, or index
       * @property {number} index index of the selected item
       */
      this.$emit('select', value, index);
    },
    handleBack() {
      this.showCustomInput = false;
    },
    /**
     * Emits close event when v-dialog requests to be closed
     */
    handleDialogInput(isOpen) {
      if (!isOpen) {
        /**
         * Fired when v-dialog requests to be closed: function() => void
         *
         * @type {click}
         */
        this.$emit('close');
      }
    },
    handleDone() {
      this.$emit('select', this.selected);
    },
    /**
     * Sets the selection
     */
    handleSelect(value, index) {
      this.emitSelect(value, index);
      if (value === 'custom') {
        this.showCustomInput = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";
@use "~@nuskin/ns-core-styles/src/scss/other";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";
@use "~@nuskin/ns-core-styles/src/scss/global.mixins";

* {
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
}

.ns-dropdown-modal__temp-container {
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  padding: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.ns-dropdown-modal__temp-inner {
  border-radius: 8px;
  width: 100%;
  height: 100%;
  box-shadow: rgba(0, 0, 0, 0.25) 0 8px 8px 0;
  z-index: 999;
  overflow: hidden;
}

::v-deep .ns-dropdown-modal {
  border-radius: 10px;
  height: 100%;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: white;
}

.back-button {
  position: absolute;
  top: 5px;
  left: 10px;
  padding: 10px;
  cursor: pointer;
}

.back-button-icon {
  width: 22px;
  height: 22px;
}

.close-button {
  position: absolute;
  top: 5px;
  right: 10px;
  padding: 10px;
  cursor: pointer;
}

.modal-title {
  @include global.title-small-bold;
  text-align: center;
  padding: 15px;
  margin: 0;
  border-bottom: 1px solid map.get(colors.$themeColors, color-gray-4);
  min-height: 51px;
}

.ns-dropdown-modal__custom-input {
  margin: 0 auto;
  max-width: 160px;

  input {
    border-radius: map.get(other.$otherUtils, global-radius);
    height: 45px;
    text-align: center;
  }
}

.ns-dropdown-modal__custom-input--border {
  position: relative;
  margin: 22px 0;
  border: 1px solid map.get(colors.$themeColors, color-interactive-8);
  border-radius: map.get(other.$otherUtils, global-radius);
  text-align: center;
  transition: map.get(other.$otherUtils, global-transition);

  &.ns-dropdown-modal__custom-input-error,
  &.ns-dropdown-modal__custom-input-error:focus {
    background-color: white;
    border: 1px solid #d0021b;
    border-left: 6px solid #d0021b;
  }
}

.ns-dropdown-modal__error-tag {
  position: absolute;
  top: 100%;
  left: 0;
  display: block;
  margin: 0;
  // margin: 0 0 10px;
  width: max-content;
  color: #d0021b;
  font-size: 12px;
  line-height: 22px;
  letter-spacing: -0.1px;
}

.modal-list {
  padding: 0;
  overflow-y: scroll;
  height: auto;
}

// Menu items styles

.modal-list > ::v-deep * {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-top: 1px solid map.get(colors.$themeColors, color-gray-4);
  padding: 10px 15px;
  min-height: 37px;
  // height: 37px;
  // background-color: white;
  transition: map.get(other.$otherUtils, global-transition) !important;
}

.modal-list > ::v-deep *:first-child {
  border-top: none;
}

.modal-list > ::v-deep *:hover {
  background-color: map.get(colors.$themeColors, color-interactive-5);
}

.modal-list > ::v-deep .selected {
  color: map.get(colors.$themeColors, color-interactive-7);
  font-weight: map.get(typographyVariables.$typography, font-weight-semibold);
}

.modal-list > ::v-deep .selected::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 3px;
  // height: calc(100% - 8px);
  background-color: map.get(colors.$themeColors, color-interactive-7);
}
</style>
